import { createApiClientForEndpoint } from "../lib/apiClient";

const api = createApiClientForEndpoint("alarms");

export const fetchAlarmButtonTypes = () => api.get("/alarm/button-types");

export const fetchAllAlarms = () => api.get("/alarms");
